// import React, { useEffect, useState } from "react";
// import { Card, Col, Row } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import { fetchFullInventoryReport } from "api/apis";
// import CountUp from "react-countup";

// interface VariantAttribute {
//   label: string;
//   value: string | number;
//   valueType: string;
//   _id: string;
// }

// interface ProductVariant {
//   sku: string;
//   price: number;
//   images: string[];
//   quantity: number;
//   attributes: VariantAttribute[];
//   _id: string;
// }

// interface VariantSKU {
//   sku: string;
//   currentStock: number;
//   totalSold: number;
//   _id: string;
// }

// interface Product {
//   _id: string;
//   name: string;
//   sku: string;
//   slug: string;
//   images: string[];
//   attributeSet: string;
//   isSimpleProduct: boolean;
//   variants: ProductVariant[];
//   __v: number;
// }

// interface InventoryItem {
//   _id: string;
//   product: Product;
//   variantSKUs: VariantSKU[];
//   currentStock: number;
//   totalSold: number;
//   history: any[];
//   lastUpdated: string;
//   __v: number;
// }

// interface InventoryResponse {
//   success: boolean;
//   data: InventoryItem[];
// }

// const Status = ({ quantity }: { quantity: number }) => {
//   const getStatus = (qty: number) => {
//     if (qty > 5) return "In Stock";
//     if (qty > 0) return "Few Left";
//     return "Sold Out";
//   };

//   const getStatusClass = (qty: number) => {
//     if (qty > 5) return "success";
//     if (qty > 0) return "warning";
//     return "danger";
//   };

//   return (
//     <span
//       className={`badge bg-${getStatusClass(
//         quantity
//       )}-subtle text-${getStatusClass(quantity)}`}
//     >
//       {getStatus(quantity)}
//     </span>
//   );
// };

// const StockReport = () => {
//   const [inventory, setInventory] = useState<InventoryItem[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [statusCounts, setStatusCounts] = useState({
//     inStock: 0,
//     fewLeft: 0,
//     soldOut: 0,
//   });

//   const getStatus = (quantity: number): string => {
//     if (quantity > 5) return "In Stock";
//     if (quantity > 0) return "Few Left";
//     return "Sold Out";
//   };

//   const getStatusClass = (quantity: number): string => {
//     if (quantity > 5) return "success";
//     if (quantity > 0) return "warning";
//     return "danger";
//   };

//   useEffect(() => {
//     const fetchInventory = async () => {
//       try {
//         const response: InventoryResponse = await fetchFullInventoryReport();
//         if (response.success) {
//           // First, flatten all variants from all products
//           const allVariants: Array<{
//             item: InventoryItem;
//             variant: VariantSKU;
//             lastUpdated: string;
//           }> = [];

//           response.data.forEach((item: InventoryItem) => {
//             if (item.variantSKUs && item.variantSKUs.length > 0) {
//               item.variantSKUs.forEach((variant: VariantSKU) => {
//                 allVariants.push({
//                   item,
//                   variant,
//                   lastUpdated: item.lastUpdated,
//                 });
//               });
//             } else {
//               // For simple products without variants, treat them as a single variant
//               allVariants.push({
//                 item,
//                 variant: {
//                   sku: item.product.sku,
//                   currentStock: item.currentStock,
//                   totalSold: item.totalSold,
//                   _id: item._id,
//                 },
//                 lastUpdated: item.lastUpdated,
//               });
//             }
//           });

//           // Sort all variants by last updated (newest first) and take first 5
//           const sortedVariants = [...allVariants]
//             .sort(
//               (a, b) =>
//                 new Date(b.lastUpdated).getTime() -
//                 new Date(a.lastUpdated).getTime()
//             )
//             .slice(0, 5);

//           // Transform back to inventory items structure for rendering
//           const latestInventory = sortedVariants.map(({ item, variant }) => ({
//             ...item,
//             // For rendering, we'll use only the relevant variant
//             variantSKUs: [variant],
//             // Override currentStock and totalSold for simple products
//             currentStock: variant.currentStock,
//             totalSold: variant.totalSold,
//           }));

//           setInventory(latestInventory);

//           // Calculate status counts (same as before)
//           const counts = { inStock: 0, fewLeft: 0, soldOut: 0 };
//           response.data.forEach((item: InventoryItem) => {
//             if (item.variantSKUs && item.variantSKUs.length > 0) {
//               item.variantSKUs.forEach((variant: VariantSKU) => {
//                 const status = getStatus(variant.currentStock);
//                 if (status === "In Stock") counts.inStock++;
//                 else if (status === "Few Left") counts.fewLeft++;
//                 else counts.soldOut++;
//               });
//             } else {
//               const status = getStatus(item.currentStock);
//               if (status === "In Stock") counts.inStock++;
//               else if (status === "Few Left") counts.fewLeft++;
//               else counts.soldOut++;
//             }
//           });
//           setStatusCounts(counts);
//         }
//       } catch (error) {
//         console.error("Failed to fetch inventory:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchInventory();
//   }, []);

//   const getVariantAttributes = (
//     variants: ProductVariant[],
//     sku: string
//   ): string => {
//     const variant = variants.find((v: ProductVariant) => v.sku === sku);
//     if (!variant) return "";

//     return variant.attributes
//       .map((attr: VariantAttribute) => `${attr.label}: ${attr.value}`)
//       .join(", ");
//   };

//   if (loading) {
//     return (
//       <Col xxl={9}>
//         <Card>
//           <Card.Header className="align-items-center d-flex">
//             <h4 className="card-title mb-0 flex-grow-1">Stock Report</h4>
//           </Card.Header>
//           <Card.Body className="text-center py-4">
//             <div className="spinner-border text-primary" role="status">
//               <span className="visually-hidden">Loading...</span>
//             </div>
//           </Card.Body>
//         </Card>
//       </Col>
//     );
//   }

//   return (
//     <React.Fragment>
//       <Col xxl={9}>
//         <Card>
//           <Card.Header className="align-items-center d-flex">
//             <h4 className="card-title mb-0 flex-grow-1">Stock Report</h4>
//             <div className="flex-shrink-0">
//               <Link to="/inventory" className="btn btn-soft-info btn-sm">
//                 <i className="ri-file-list-3-line align-middle"></i> View Full
//                 Inventory
//               </Link>
//             </div>
//           </Card.Header>

//           <Card.Body>
//             {/* <Row className="row-cols-xxl-3 row-cols-lg-3 row-cols-md-2 row-cols-1 mb-4">
//               <Col>
//                 <Card className="shadow-sm border-0 overflow-hidden card-animate">
//                   <Card.Body className="p-4 z-1 position-relative">
//                     <div className="d-flex align-items-center gap-3">
//                       <div className="flex-shrink-0 avatar-sm">
//                         <div className="avatar-title bg-success-subtle text-success fs-3 rounded">
//                           <i className="ph-check-circle"></i>
//                         </div>
//                       </div>
//                       <div>
//                         <h4 className="fs-22 fw-semibold mb-1">
//                           <CountUp
//                             start={0}
//                             end={statusCounts.inStock}
//                             duration={3}
//                             separator=","
//                           />
//                         </h4>
//                         <p className="mb-0 fw-medium text-uppercase fs-14">
//                           In Stock
//                         </p>
//                       </div>
//                     </div>
//                   </Card.Body>
//                 </Card>
//               </Col>
//               <Col>
//                 <Card className="shadow-sm border-0 overflow-hidden card-animate">
//                   <Card.Body className="p-4 z-1 position-relative">
//                     <div className="d-flex align-items-center gap-3">
//                       <div className="flex-shrink-0 avatar-sm">
//                         <div className="avatar-title bg-warning-subtle text-warning fs-3 rounded">
//                           <i className="ph-warning-circle"></i>
//                         </div>
//                       </div>
//                       <div>
//                         <h4 className="fs-22 fw-semibold mb-1">
//                           <CountUp
//                             start={0}
//                             end={statusCounts.fewLeft}
//                             duration={3}
//                             separator=","
//                           />
//                         </h4>
//                         <p className="mb-0 fw-medium text-uppercase fs-14">
//                           Few Left
//                         </p>
//                       </div>
//                     </div>
//                   </Card.Body>
//                 </Card>
//               </Col>
//               <Col>
//                 <Card className="shadow-sm border-0 overflow-hidden card-animate">
//                   <Card.Body className="p-4 z-1 position-relative">
//                     <div className="d-flex align-items-center gap-3">
//                       <div className="flex-shrink-0 avatar-sm">
//                         <div className="avatar-title bg-danger-subtle text-danger fs-3 rounded">
//                           <i className="ph-x-circle"></i>
//                         </div>
//                       </div>
//                       <div>
//                         <h4 className="fs-22 fw-semibold mb-1">
//                           <CountUp
//                             start={0}
//                             end={statusCounts.soldOut}
//                             duration={3}
//                             separator=","
//                           />
//                         </h4>
//                         <p className="mb-0 fw-medium text-uppercase fs-14">
//                           Sold Out
//                         </p>
//                       </div>
//                     </div>
//                   </Card.Body>
//                 </Card>
//               </Col>
//             </Row> */}

//             <div className="table-responsive table-card">
//               <table className="table table-borderless table-centered align-middle table-nowrap mb-0">
//                 <thead className="text-muted table-light">
//                   <tr>
//                     <th scope="col" style={{ width: "15%" }}>
//                       SKU
//                     </th>
//                     <th scope="col" style={{ width: "35%" }}>
//                       Product
//                     </th>
//                     <th scope="col" style={{ width: "15%" }}>
//                       Status
//                     </th>
//                     <th scope="col" style={{ width: "15%" }}>
//                       Quantity
//                     </th>
//                     <th scope="col" style={{ width: "20%" }}>
//                       Sold
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {inventory.length === 0 ? (
//                     <tr>
//                       <td colSpan={5} className="text-center py-4">
//                         No inventory records found.
//                       </td>
//                     </tr>
//                   ) : (
//                     inventory.flatMap((item: InventoryItem) => {
//                       if (item.variantSKUs && item.variantSKUs.length > 0) {
//                         return item.variantSKUs.map((variant: VariantSKU) => (
//                           <tr key={`${item._id}-${variant.sku}`}>
//                             <td style={{ width: "15%" }}>
//                               <Link to="#" className="fw-medium link-primary">
//                                 {variant.sku}
//                               </Link>
//                             </td>
//                             <td style={{ width: "35%" }}>
//                               <div className="d-flex align-items-center">
//                                 <div className="flex-grow-1">
//                                   <Link to="#" className="text-reset">
//                                     {item.product.name}
//                                   </Link>
//                                   <small className="text-muted d-block">
//                                     {getVariantAttributes(
//                                       item.product.variants,
//                                       variant.sku
//                                     )}
//                                   </small>
//                                 </div>
//                               </div>
//                             </td>
//                             <td style={{ width: "15%" }}>
//                               <Status quantity={variant.currentStock} />
//                             </td>
//                             <td style={{ width: "15%" }}>
//                               {variant.currentStock}
//                             </td>
//                             <td style={{ width: "20%" }}>
//                               {variant.totalSold}
//                             </td>
//                           </tr>
//                         ));
//                       }
//                       return (
//                         <tr key={item._id}>
//                           <td style={{ width: "15%" }}>
//                             <Link to="#" className="fw-medium link-primary">
//                               {item.product.sku}
//                             </Link>
//                           </td>
//                           <td style={{ width: "35%" }}>
//                             <div className="d-flex align-items-center">
//                               <div className="flex-grow-1">
//                                 <Link to="#" className="text-reset">
//                                   {item.product.name}
//                                 </Link>
//                               </div>
//                             </div>
//                           </td>
//                           <td style={{ width: "15%" }}>
//                             <Status quantity={item.currentStock} />
//                           </td>
//                           <td style={{ width: "15%" }}>{item.currentStock}</td>
//                           <td style={{ width: "20%" }}>{item.totalSold}</td>
//                         </tr>
//                       );
//                     })
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           </Card.Body>
//         </Card>
//       </Col>
//     </React.Fragment>
//   );
// };

// export default StockReport;

import React, { useEffect, useState, useMemo } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { fetchFullInventoryReport } from "api/apis";
import CountUp from "react-countup";
import TableContainer from "Common/TableContainer";

interface VariantAttribute {
  label: string;
  value: string | number;
  valueType: string;
  _id: string;
}

interface ProductVariant {
  sku: string;
  price: number;
  images: string[];
  quantity: number;
  attributes: VariantAttribute[];
  _id: string;
}

interface VariantSKU {
  sku: string;
  currentStock: number;
  totalSold: number;
  _id: string;
}

interface Product {
  _id: string;
  name: string;
  sku: string;
  slug: string;
  images: string[];
  attributeSet: string;
  isSimpleProduct: boolean;
  variants: ProductVariant[];
  __v: number;
}

interface InventoryItem {
  _id: string;
  product: Product;
  variantSKUs: VariantSKU[];
  currentStock: number;
  totalSold: number;
  history: any[];
  lastUpdated: string;
  __v: number;
}

interface InventoryResponse {
  success: boolean;
  data: InventoryItem[];
}

const Status = ({ quantity }: { quantity: number }) => {
  const getStatus = (qty: number) => {
    if (qty > 5) return "In Stock";
    if (qty > 0) return "Few Left";
    return "Sold Out";
  };

  const getStatusClass = (qty: number) => {
    if (qty > 5) return "success";
    if (qty > 0) return "warning";
    return "danger";
  };

  return (
    <span
      className={`badge bg-${getStatusClass(
        quantity
      )}-subtle text-${getStatusClass(quantity)}`}
    >
      {getStatus(quantity)}
    </span>
  );
};

const StockReport = () => {
  const [inventory, setInventory] = useState<InventoryItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [statusCounts, setStatusCounts] = useState({
    inStock: 0,
    fewLeft: 0,
    soldOut: 0,
  });

  const getStatus = (quantity: number): string => {
    if (quantity > 5) return "In Stock";
    if (quantity > 0) return "Few Left";
    return "Sold Out";
  };

  const getStatusClass = (quantity: number): string => {
    if (quantity > 5) return "success";
    if (quantity > 0) return "warning";
    return "danger";
  };

  const getVariantAttributes = (
    variants: ProductVariant[],
    sku: string
  ): string => {
    const variant = variants.find((v: ProductVariant) => v.sku === sku);
    if (!variant) return "";

    return variant.attributes
      .map((attr: VariantAttribute) => `${attr.label}: ${attr.value}`)
      .join(", ");
  };

  useEffect(() => {
    const fetchInventory = async () => {
      try {
        const response: InventoryResponse = await fetchFullInventoryReport();
        if (response.success) {
          // First, flatten all variants from all products
          const allVariants: Array<{
            item: InventoryItem;
            variant: VariantSKU;
            lastUpdated: string;
          }> = [];

          response.data.forEach((item: InventoryItem) => {
            if (item.variantSKUs && item.variantSKUs.length > 0) {
              item.variantSKUs.forEach((variant: VariantSKU) => {
                allVariants.push({
                  item,
                  variant,
                  lastUpdated: item.lastUpdated,
                });
              });
            } else {
              // For simple products without variants, treat them as a single variant
              allVariants.push({
                item,
                variant: {
                  sku: item.product.sku,
                  currentStock: item.currentStock,
                  totalSold: item.totalSold,
                  _id: item._id,
                },
                lastUpdated: item.lastUpdated,
              });
            }
          });

          // Transform back to inventory items structure for rendering
          const fullInventory = allVariants.map(({ item, variant }) => ({
            ...item,
            // For rendering, we'll use only the relevant variant
            variantSKUs: [variant],
            // Override currentStock and totalSold for simple products
            currentStock: variant.currentStock,
            totalSold: variant.totalSold,
          }));

          setInventory(fullInventory);

          // Calculate status counts
          const counts = { inStock: 0, fewLeft: 0, soldOut: 0 };
          fullInventory.forEach((item: InventoryItem) => {
            const status = getStatus(item.currentStock);
            if (status === "In Stock") counts.inStock++;
            else if (status === "Few Left") counts.fewLeft++;
            else counts.soldOut++;
          });
          setStatusCounts(counts);
        }
      } catch (error) {
        console.error("Failed to fetch inventory:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchInventory();
  }, []);

  // Define columns for the table
  const columns = useMemo(
    () => [
      {
        Header: "SKU",
        accessor: (cellProps: any) => {
          const variant = cellProps.variantSKUs[0];
          return (
            <Link to="#" className="fw-medium link-primary">
              {variant.sku}
            </Link>
          );
        },
      },
      {
        Header: "Product",
        accessor: (cellProps: any) => {
          const variant = cellProps.variantSKUs[0];
          return (
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <Link to="#" className="text-reset">
                  {cellProps?.product?.name}
                </Link>
                {cellProps?.product?.variants &&
                  cellProps?.product?.variants?.length > 0 && (
                    <small className="text-muted d-block">
                      {getVariantAttributes(
                        cellProps?.product?.variants,
                        variant?.sku
                      )}
                    </small>
                  )}
              </div>
            </div>
          );
        },
      },
      {
        Header: "Status",
        accessor: (cellProps: any) => {
          const variant = cellProps.variantSKUs[0];
          return <Status quantity={variant.currentStock} />;
        },
      },
      {
        Header: "Quantity",
        accessor: (cellProps: any) => {
          const variant = cellProps.variantSKUs[0];
          return variant.currentStock;
        },
      },
      {
        Header: "Sold",
        accessor: (cellProps: any) => {
          const variant = cellProps.variantSKUs[0];
          return variant.totalSold;
        },
      },
    ],
    []
  );

  if (loading) {
    return (
      <Col xxl={9}>
        <Card>
          <Card.Header className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">Stock Report</h4>
          </Card.Header>
          <Card.Body className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </Card.Body>
        </Card>
      </Col>
    );
  }

  return (
    <Col xxl={15}>
      <Card>
        <Card.Header className="align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Stock Report</h4>
          <div className="flex-shrink-0">
            <Link to="/inventory" className="btn btn-soft-info btn-sm">
              <i className="ri-file-list-3-line align-middle"></i> View Full
              Inventory
            </Link>
          </div>
        </Card.Header>

        <Card.Body>
          <Row className="row-cols-xxl-3 row-cols-lg-3 row-cols-md-2 row-cols-1 mb-4">
            <Col>
              <Card className="shadow-sm border-0 overflow-hidden card-animate">
                <Card.Body className="p-4 z-1 position-relative">
                  <div className="d-flex align-items-center gap-3">
                    <div className="flex-shrink-0 avatar-sm">
                      <div className="avatar-title bg-success-subtle text-success fs-3 rounded">
                        <i className="ph-check-circle"></i>
                      </div>
                    </div>
                    <div>
                      <h4 className="fs-22 fw-semibold mb-1">
                        <CountUp
                          start={0}
                          end={statusCounts.inStock}
                          duration={3}
                          separator=","
                        />
                      </h4>
                      <p className="mb-0 fw-medium text-uppercase fs-14">
                        In Stock
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className="shadow-sm border-0 overflow-hidden card-animate">
                <Card.Body className="p-4 z-1 position-relative">
                  <div className="d-flex align-items-center gap-3">
                    <div className="flex-shrink-0 avatar-sm">
                      <div className="avatar-title bg-warning-subtle text-warning fs-3 rounded">
                        <i className="ph-warning-circle"></i>
                      </div>
                    </div>
                    <div>
                      <h4 className="fs-22 fw-semibold mb-1">
                        <CountUp
                          start={0}
                          end={statusCounts.fewLeft}
                          duration={3}
                          separator=","
                        />
                      </h4>
                      <p className="mb-0 fw-medium text-uppercase fs-14">
                        Few Left
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col>
              <Card className="shadow-sm border-0 overflow-hidden card-animate">
                <Card.Body className="p-4 z-1 position-relative">
                  <div className="d-flex align-items-center gap-3">
                    <div className="flex-shrink-0 avatar-sm">
                      <div className="avatar-title bg-danger-subtle text-danger fs-3 rounded">
                        <i className="ph-x-circle"></i>
                      </div>
                    </div>
                    <div>
                      <h4 className="fs-22 fw-semibold mb-1">
                        <CountUp
                          start={0}
                          end={statusCounts.soldOut}
                          duration={3}
                          separator=","
                        />
                      </h4>
                      <p className="mb-0 fw-medium text-uppercase fs-14">
                        Sold Out
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <TableContainer
            columns={columns}
            data={inventory}
            iscustomPageSize={true}
            customPageSize={10}
            tableClass="table-borderless table-centered align-middle table-nowrap mb-0"
            theadClass="text-muted table-light"
            SearchPlaceholder="Search products..."
            manualPagination={false}
          />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default StockReport;
